// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-ath-safari .v-list__tile__content~.v-list__tile__action:not(.v-list__tile__action--stack){align-items:flex-start;padding:8px 0}.w-ath-safari .w-logo{width:28px!important;height:28px!important}", ""]);
// Exports
module.exports = exports;
